import { DEFAULT_SIGNED_UPLOAD_CONTENT_TYPE } from '@/api/postS3Files';
import {
  normalizeS3UploadContentType,
  SUPPORTED_S3_UPLOAD_CONTENT_TYPES
} from '@/api/s3UploadFileTypes';

export const CHAT_ATTACHMENT_MAX_FILE_SIZE_BYTES = 80 * 1024 * 1024;
export const CHAT_ATTACHMENT_MAX_FILES = 10;

export function getChatAttachmentFileKey(file: File) {
  return `${file.name}-${file.size}-${file.lastModified}`;
}

// Some browsers leave File.type blank or generic, so fall back to the extension.
export function getRocUploadContentType(file: File, fileName: string) {
  if (file.type && file.type !== DEFAULT_SIGNED_UPLOAD_CONTENT_TYPE) {
    return file.type;
  }

  const extension = `.${fileName.split('.').pop()?.toLowerCase()}`;
  for (const [contentType, extensions] of Object.entries(
    SUPPORTED_S3_UPLOAD_CONTENT_TYPES
  )) {
    if (extensions.includes(extension)) {
      return contentType;
    }
  }

  return DEFAULT_SIGNED_UPLOAD_CONTENT_TYPE;
}

export function isPdfChatAttachment(file: Pick<File, 'name' | 'type'>) {
  return (
    normalizeS3UploadContentType(file.type) === 'application/pdf' &&
    file.name.toLowerCase().endsWith('.pdf')
  );
}
